import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NavigationEnd } from '@angular/router';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-keywords-section',
  templateUrl: './keywords-section.component.html',
  styleUrls: ['./keywords-section.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class KeywordsSectionComponent implements OnInit, OnDestroy {
  currentUrl: string = '';
  baseUrl: string = environment.TENDER.BASE_URL;

  private routerSubscription: Subscription | undefined;

  constructor(private activatedRoute: ActivatedRoute, private router: Router) {
    this.getRoute();
  }

  resolverData: any;
  ngOnInit(): void {
    this.resolveTenderNewMain();
    this.routerSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = event.url;
      }
    });
  }

  statesList: any
  authorityList: any;
  categoryList: any;
  procurementList: any;
  trendingSearchList: any;

  /**
   * Navigate to tenders page with full page reload
   * This bypasses Angular's internal routing and triggers a full page reload
   * to pull fresh data from the CDN instead of using cached data
   */
  navigate(event: MouseEvent, link: string): void {
    event.preventDefault();
    // Use window.location.href to reload the page and pull fresh data from CDN
    window.location.href = link;
  }

  resolveTenderNewMain() {
    this.activatedRoute.data.subscribe((rawData: any) => {
      let resolverData: any = rawData['tendersResolver'];
      if (resolverData) {
        this.statesList = resolverData?.states?.data;
        this.authorityList = resolverData?.authorities?.data;
        this.categoryList = resolverData?.categories?.data;
        this.procurementList = resolverData?.procurement?.data;
        this.trendingSearchList = resolverData?.trendingSearch?.data;
      }

      // let resolverData: any = rawData.homePageResolver;
      // if (resolverData) {
      //   this.statesList = resolverData?.states?.data;
      //   this.authorityList = resolverData?.authorities?.data;
      //   this.categoryList = resolverData?.categories?.data;
      //   this.procurementList = resolverData?.procurement?.data;
      // } else {
      //   // const ALL_LISTING_STATES: any = makeStateKey<object>(PARAMS.STATIC_PARAMS.ALL_LISTING_STATES);
      //   // const ALL_LISTING_AUTHORITY: any = makeStateKey<object>(PARAMS.STATIC_PARAMS.ALL_LISTING_AUTHORITY);
      //   // const ALL_LISTING_CATEGORIES: any = makeStateKey<object>(PARAMS.STATIC_PARAMS.ALL_LISTING_CATEGORIES);
      //   // const ALL_LISTING_PROCUREMENT: any = makeStateKey<object>(PARAMS.STATIC_PARAMS.ALL_LISTING_PROCUREMENT);

      //   // this.sharedService.retrieveStateListTenders().subscribe((res: any) => {
      //   //   this.statesList = res?.data;
      //   //   if (this.sharedService.isServer) {
      //   //     this.transferState.set(ALL_LISTING_STATES, this.statesList);
      //   //   }
      //   // });

      //   // this.sharedService.retrieveAuthorityListTenders().subscribe((res: any) => {
      //   //   this.authorityList = res?.data;
      //   //   if (this.sharedService.isServer) {
      //   //     this.transferState.set(ALL_LISTING_AUTHORITY, this.authorityList);
      //   //   }
      //   // });

      //   // this.sharedService.retrieveExporeByCategories().subscribe((res: any) => {
      //   //   this.categoryList = res?.data;
      //   //   if (this.sharedService.isServer) {
      //   //     this.transferState.set(ALL_LISTING_CATEGORIES, this.categoryList);
      //   //   }
      //   // });

      //   // this.sharedService.retrieveprocurement().subscribe((res: any) => {
      //   //   this.procurementList = res?.data;
      //   //   if (this.sharedService.isServer) {
      //   //     this.transferState.set(ALL_LISTING_PROCUREMENT, this.procurementList);
      //   //   }
      //   // });
      // }
    });
  }
  private getRoute(): void {
    this.router.events.forEach((event: any) => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = event.url;
      }
    });
  }
  ngOnDestroy(): void {
    this.routerSubscription?.unsubscribe();
  }
}
